import './Header.css';
import {useNavigate} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from "../../context/AuthContext";
import { getToken, removeToken } from '../../helpers';
import { API } from '../../constant';
import Loading from "../../Components/Hooks/Loading";

function Header(props) {
    const { user, logout } = useAuthContext();
    const navigate = useNavigate();
    const[menuItemLink, setmenuItemLink] = useState();
    const [isActiveMenu, setActiveMenu] = useState(false);
    const [loading, setLoading] = useState();
    const [logoImage, setLogoImage] = useState();
    const[menu, setMenu] = useState();

    let HeaderType = props.type;
    let UID;
    if(user!==undefined)
        UID=user.id;

    const toggleMenu = () => {
        setActiveMenu(!isActiveMenu);
    };
   
    const logoutFunction = ()=>{
        // removeToken();
        logout();
    }
    // console.log(UID);
    useEffect(()=>{
        const fetchUser = async()=>{
            setLoading(true);
            try {
                
                const response = await fetch(`${API}/users/${UID}?populate=subscriptions`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    // set the auth token to the user's jwt
                    Authorization: `Bearer ${getToken()}`,
                },
                });
                
                const responseData = await response.json();
                // console.log(responseData)
                
                const subscription = responseData.hasOwnProperty('subscriptions');
                // console.log(subscription)
                if(subscription){
                    if(responseData.subscriptions.length>0){
                        setmenuItemLink(<li onClick = {toggleMenu}><Link to="/dashboard">My Subscriptions</Link></li>);
                    }else{
                        setmenuItemLink(<li onClick = {toggleMenu}><Link to="/go-premium">Go Premium</Link></li>);
                    }
                }

                const appInfoResponse = await fetch(`${API}/app-information?populate=*`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        // set the auth token to the user's jwt
                        Authorization: `Bearer ${getToken()}`,
                    },
                    });

                if (!appInfoResponse.ok) {
                    console.warn("Header: Failed to load app info:", appInfoResponse.status);
                    return; // Don't try to parse if request failed
                }

                const appInfo =  await appInfoResponse.json();
                setLogoImage(appInfo.data.attributes.app_logo.data.attributes.url);
                const mainMenu = appInfo.data.attributes.menu;
                setMenu(mainMenu);


            } catch (error) {
                console.warn("Header: Error loading app data (non-critical):", error.message);
            } 
            
        };
        
    fetchUser();
    setLoading(false);
    },[UID]);

    

    if (loading || menu==undefined) {
        return <Loading/>
    }

//   console.log(menu);
    
    
    
    return (
            <div className={isActiveMenu ? "cope-ahead-header active" : "cope-ahead-header bg-blue"}>

                <div className="cope-ahead-header-inner">
                    <div className="back"></div>
                    <div className="app-logo-img"><Link to="/"> <img src={logoImage} alt="User-img"/></Link></div>
                    {/* <div className={isActiveMenu ? "app-logo-img" : "user-img back-button"}>{isActiveMenu ? <Link to="/"> <img src={logoImage} alt="User-img"/></Link> : (HeaderType==="Secondary"?<button className="button-left-arrow" onClick={() => navigate(-1)}><span></span></button>:<Link to="/"><img src={logoImage} alt="User-img"/></Link>)}</div> */}
                    {/* <div className="app-title">{props.title}</div> */}
                    {/* <div className="app-title">{props.title}</div> */}
                    <div className="menu-button">
                        <button className={isActiveMenu ? "close" : "open"} onClick ={toggleMenu}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
                <div className={isActiveMenu ? "cope-ahead-menu bg-gradient-light active" : "cope-ahead-menu"}>
                    <div className="menu-items">
                         <ul>
                        {/* {isActiveMenu? mainMenu : null} */}
                        {menu.map((item, index)=>{
                            return<li className="hover-bounce" key={index} onClick = {item.menu_link=='/Login'?logoutFunction:toggleMenu}><Link to={item.menu_link}>{item.item_name}</Link></li>
                        })}
                        </ul>
                    </div>
                </div>
            </div>
    );
}
export default Header;
